import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/ArticlePage";
import { allArticles } from "../mocks/articles";

const articles = allArticles;

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
];

articles.forEach((article) => {
  routes.push({
    path: `/${article.slug}`,
    element: <ArticlePage article={article} />,
  });
});

routes.push({
  path: "*",
  element: <NotFound />,
});

export default routes;